// extracted by mini-css-extract-plugin
module.exports = {"loading":"spinner_loading__381Yl"};